
import Vue from 'vue';
import Component from 'vue-class-component';
import { SnackEvent, SNACK_EVENT_NAME } from './core/events';

@Component({ name: 'App' })
export default class App extends Vue {
  snackbar = false;

  snackTimeout = 2000;

  snackColor = '';

  snackMessage = '';

  snackMultiline = false;

  get customer() {
    return process.env.VUE_APP_CUSTOMER;
  }

  async mounted() {
    const config = await import(`../customers/${this.customer}/config`);
    document.title = config.NAME;
    this.favicon();
    this.$root.$on(SNACK_EVENT_NAME, this.onSnack);
  }

  onSnack(snackEvent: SnackEvent) {
    this.snackTimeout = snackEvent.timeout;
    this.snackColor = snackEvent.color;
    this.snackMessage = snackEvent.message;
    this.snackMultiline = snackEvent.multiline;
    this.snackbar = true;
  }

  beforeDestroy() {
    this.$root.$off(SNACK_EVENT_NAME, this.onSnack);
  }

  async favicon() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const favicon = document.getElementById('favicon') as any;
    if (favicon) favicon.href = `${this.customer}.svg`;
  }
}
